import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.85, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLines({
    lines,
    className = "",
    lineClassName = "",
    delay = 0.25,
    stagger = 0.14,
}) {
    return (
        <span className={className}>
            {lines.map((line, i) => (
                <span
                    key={i}
                    className="block overflow-hidden pb-[0.12em] -mb-[0.12em]"
                >
                    <motion.span
                        className={`block ${lineClassName}`}
                        initial={{ y: "112%" }}
                        animate={{ y: "0%" }}
                        transition={{
                            duration: 0.95,
                            ease: EASE,
                            delay: delay + i * stagger,
                        }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </span>
    );
}

export function Fade({ children, delay = 0, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut", delay }}
        >
            {children}
        </motion.div>
    );
}
